<style lang="less">
.sidebar {
  width: 100px;
  background: #35495d;
  position: relative;
  z-index: 999;

  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  font-size: 14px;
  color: #b2bbce;
  .ivu-poptip-inner {
    box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.3);
  }
  .ivu-poptip-popper[x-placement='right-start'] .ivu-poptip-arrow {
    top: 28px !important;
  }
  .ivu-poptip-popper[x-placement='right-end'] .ivu-poptip-arrow {
    bottom: 27px;
  }
  .menu-pop {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #35495d;

    .link {
      display: block;
      line-height: 36px;
      font-size: 14px;
      width: 100%;
      text-align: center;
      &.ac {
        color: #d8321f;
      }
    }
  }

  .logo-wapper {
    position: relative;
    height: 70px;
    .logo-img {
      width: 90px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 22px;
      color: #eacd51;
    }
  }

  .menus {
    width: 100%;
    margin-top: 27px;
    padding-bottom: 60px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
    .menu-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      flex: 0;

      width: 70px;
      height: 65px;
      color: #b2bbce;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        background-color: #2c3945;
      }

      .sub-icon {
        position: absolute;
        right: 2px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .active {
      color: #fff;
      background-color: #2c3945;
    }
  }
}
</style>


<template>
  <div class="sidebar">
    <a :title="$store.getters.gatedLaunch ? '灰度' : 'logo'" class="logo-wapper" href="#">
      <img src="~assets/img/login-logo2.png" class="logo-img" alt="logo">
      <!-- <span class="logo-img">Y·TIME</span> -->
    </a>
    <div id="sidebarMenus" class="menus">
      <div v-for="(menu, index) in menus" :key="menu.id">
        <Poptip v-if="menu.node" :placement="placement(index, menu)" trigger="hover">
          <div :class="{'menu-item': true, 'active': menu.name == activeName}">
            <img v-if="menu.name == activeName" :src="menu.iconCur" :alt="menu.name">
            <img v-else :src="menu.icon" :alt="menu.name">
            <span>{{menu.name}}</span>
            <img class="sub-icon" src="~assets/img/menu-submenu.png" alt="has-sub-menu">
          </div>
          <div class="menu-pop" slot="content">
            <a class="link" :class="{ 'ac': link.name === ($route.meta.breadText || $route.name) }" :target="link.name == '新签到提醒' ? '_blank' : ''" v-for="link in menu.node" :href="link._url" :key="link.id">{{link.name}}</a>
          </div>
        </Poptip>
        <!-- tips: 除管理端以外的菜单没有二级菜单, 但是却使用了二级菜单作为一级菜单 导致没有菜单激活效果 -->
        <!-- 条件1: this.$store.state.adminInfo.port_type != 0 -->
        <!-- 条件2: 此时使用url进行判断  否则会出现同父级下的两个子菜单放出来  父级名相同了 -->
        <a v-else :class="{'menu-item': true, 'active': $store.state.adminInfo.port_type != 0 ? menu.url == activeUrl : menu.name == activeName}" :href="menu._url">
          <img v-if="$store.state.adminInfo.port_type != 0 ? menu.url == activeUrl : menu.name == activeName" :src="menu.iconCur" alt="">
          <img v-else :src="menu.icon" alt="">
          <span>{{menu.name}}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getLeftNav } from 'src/service/getData';
import { getBaseUrl } from 'utils/config';

export default {
  name: 'sidebar',
  data() {
    return {
      menuList: null,
      activeName: '',
      activeUrl: '',
      menus: ''
    };
  },

  created() {
    this.getMenuList();
  },

  watch: {
    $route() {
      this.update();
    }
  },

  methods: {
    placement(index, menu) {
      return menu.name==='财务' && index > 3 ? 'right' : index >= this.menus.length - Math.ceil(this.menus.length / 3) && this.menus.length >= 7
        ? 'right-end'
        : 'right-start';
    },
    getMenuList() {
      getLeftNav()
        .then(res => {
          if (res.data.errorcode === 0) {
            this.menuList = res.data.data;
            this.dealMenu(res.data.data);
            this.$nextTick(() => {
              this.update();
            });
          } else {
            this.$Message.error('你还没有登录噢！');
            this.$router.push({path: '/login', name: '登录', params: { from: window.location.hash }});
          }
        })
        .catch(err => {
          this.$router.push({path: '/login', name: '登录', params: { from: window.location.hash }});
        });
    },
    dealMenu(menu) {
      this.menus = menu.map(item => {
        return {
          ...item,
          ...{
            icon: `/static/img/menu-icon/${item.flag}.png`,
            iconCur: `/static/img/menu-icon/${item.flag}-cur.png`,
            _url:
              item.version == 3
                ? `#${item.url}`
                : `${getBaseUrl()}${item.url}`,
            node:
              item.node &&
              item.node.map(link => {
                return {
                  ...link,
                  ...{
                    _url:
                      link.version == 3
                        ? `#${link.url}`
                        : `${getBaseUrl()}${link.url}`
                  }
                };
              })
          }
        };
      });
      this.$nextTick(() => {
        const menus = document.getElementById('sidebarMenus');
        const menusItems = document.querySelectorAll('.menu-item');
        const itemHeight = menusItems[0].clientHeight;
        const itemTotalH = itemHeight * menusItems.length;
        if (menus.offsetHeight >= itemTotalH) {
          menus.style.overflowY = 'auto';
        } else {
          menus.style.overflowY = 'scroll';
        }
        window.addEventListener('resize', this.handleResize);
      });
    },
    handleResize() {
      this.dealMenu(this.menuList);
      window.removeEventListener('resize', this.handleResize);
    },
    //更新展开的子目录和当前选择项
    update() {
      this.activeName = this.$route.meta.parentName || this.$route.name;
      this.activeUrl = this.$route.fullPath;
    }
  }
};
</script>
